if(!customElements.get('variant-extension')) {
    class VariantExtension extends HTMLElement {
        constructor() {
            super();
            this.accessToken = '5ae59ab0a84991e0f924c83e1fa575fd';
            this.variantIdChangedUnsubscriber = undefined;
            this.metaObjectsData = [];
            this.variantDataCache = null;
            this.lastPathname = '';
        }
        async connectedCallback() {
            this.variantOptions = this.querySelector('.options');
            this.labelSelected = this.querySelector('.label-selected');
            await this._queryHandle();
            await this._initVariantData();
            this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantOptionsSortingChanged,
                this._changeVariantSelected.bind(this)
            );
            this._initVariantSelected();
            this.addEventListener('click', event => {
                if(event.target.closest('label')) {
                    if(event.target.closest('label').dataset.galleryImage) {
                        publish(PUB_SUB_EVENTS.galleryImageChanged, {
                            data: {
                                galleryImage: event.target.closest('label')?.dataset.galleryImage
                            },
                        });
                    }
                    this.labelSelected.innerHTML = event.target.closest('label')?.dataset.labelHtml;           
                }
               if (event.target.closest('input')) {
                    const existing = document.getElementById('custom-input-properties');
                    if (existing) existing.remove();

                    const form = document.querySelector('form[data-type="add-to-cart-form"]');
                    if (form) {
                        const newInput = document.createElement('input');
                        newInput.name = event.target.closest('input').name;
                        newInput.type = 'hidden';
                        newInput.value = event.target.closest('input').value;
                        newInput.id = 'custom-input-properties';

                        form.append(newInput);
                    }
                }
            });
        }
        async _initVariantData() {
                try {
                    await fetch(`${window.location.pathname}.json`)
                    .then(response => response.json())
                    .then(data => {
                        this.variantDataCache = data?.product?.variants;
                    })
                } catch (err) {
                    console.error('Fetch error:', err);
                    return;
                }
        }
        async _queryHandle() {
            const query = `{
                        metaobjects(first: 20, type: "variant_options_extension_main") {
                            nodes {
                            option_name: field(key:"option_name") {
                                value
                            }
                                values: field(key: "values") {
                                    references(first:250) {
                                        nodes {
                                            ... on Metaobject {
                                                id
                                                label: field(key: "label") {
                                                    value
                                                }
                                                label_html: field(key: "label_html") {
                                                    value
                                                }
                                                image: field(key: "image") {
                                                        reference {
                                                        ... on MediaImage {
                                                                image {
                                                                    url
                                                                    altText
                                                                }
                                                            }
                                                        }
                                                }
                                            }
                                        }
                                    }
                            }
                        }
                    }
                }`;    
            try {
                const response = await fetch('/api/2025-01/graphql.json', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': this.accessToken,
                    },
                    body: JSON.stringify({ query })
                });
                const results = await response.json();
                this.metaObjectsData = results?.data?.metaobjects?.nodes;
            } catch (error) {
                console.error('Error fetching metaobjects:', error);
            };
        }
        async _initVariantSelected() {
            const labelSelected = document.querySelector('[data-option-handle="style"] .form__label');
            labelSelected.innerHTML = '';
            // Get full query parameters object
            const params = new URLSearchParams(window.location.search);
            // Get specific parameter values
            const variantId = params.get('variant');
            if(!variantId) {
                const selectedVariant = this.variantDataCache[0];
                const variantOptionValues = this.metaObjectsData.find(meta => meta.option_name.value === selectedVariant.option1);
                let index = 0;
                for(const node of variantOptionValues?.values?.references?.nodes) {
                    const frameStyleInput = document.querySelectorAll('[data-option-handle="style"] input');
                    const foundFrame = Array.from(frameStyleInput).find(frame => node?.label?.value.includes(frame.value));
                    const foundFrameLabel = foundFrame.nextElementSibling;
                    const labelImage = document.createElement('img');
                    labelImage.src = node?.image?.reference?.image?.url;
                    labelImage.alt = node?.image?.reference?.image?.altText ?? node?.label.value;
                    foundFrameLabel.append(labelImage);
                    const labelHtml = JSON.parse(node?.label_html?.value);
                    const htmlOutput = this._renderRichText(labelHtml);
                    foundFrame.dataset.htmlOutput = htmlOutput;
                    if(index === 0) {
                        labelSelected.innerHTML = htmlOutput;
                    }
                    index++;           
                }
            } else {
                const selectedVariant = this.variantDataCache.find(variant => parseInt(variant.id) === parseInt(variantId));
                const variantOptionValues = this.metaObjectsData.find(meta => meta.option_name.value === selectedVariant.option1);
                let index = 0;
                for(const node of variantOptionValues?.values?.references?.nodes) {
                    const frameStyleInput = document.querySelectorAll('[data-option-handle="style"] input');
                    const foundFrame = Array.from(frameStyleInput).find(frame => node?.label?.value.includes(frame.value));
                    const foundFrameLabel = foundFrame.nextElementSibling;
                    const labelImage = document.createElement('img');
                    labelImage.src = node?.image?.reference?.image?.url;
                    labelImage.alt = node?.image?.reference?.image?.altText ?? node?.label.value;
                    foundFrameLabel.append(labelImage);
                    const labelHtml = JSON.parse(node?.label_html?.value);
                    const htmlOutput = this._renderRichText(labelHtml);
                    foundFrame.dataset.htmlOutput = htmlOutput;
                    if(index === 0) {
                        labelSelected.innerHTML = htmlOutput;
                    }
                    index++;
                }
            }
        }
        _changeVariantSelected({data: {event, updateInfo, selectedOptionsValue}}) {
            const labelSelected = document.querySelector('[data-option-handle="style"] .form__label');
            labelSelected.innerHTML = '';
            const variantOptionValues = this.metaObjectsData.find(meta => meta.option_name.value === selectedOptionsValue[0]);
                let index = 0;
                for(const node of variantOptionValues?.values?.references?.nodes) {
                    const frameStyleInput = document.querySelectorAll('[data-option-handle="style"] input');
                    const foundFrame = Array.from(frameStyleInput).find(frame => node?.label?.value.includes(frame.value));
                    if(foundFrame?.nextElementSibling) {
                        const foundFrameLabel = foundFrame?.nextElementSibling.querySelector('img');
                        foundFrameLabel && foundFrameLabel.remove();
                        const labelImage = document.createElement('img');
                        labelImage.src = node?.image?.reference?.image?.url;
                        labelImage.alt = node?.image?.reference?.image?.altText ?? node?.label.value;
                        const labelHtml = JSON.parse(node?.label_html?.value);
                        const htmlOutput = this._renderRichText(labelHtml);
                        if(index === 0) {
                            labelSelected.innerHTML = htmlOutput;
                        }
                        foundFrame.dataset.htmlOutput = htmlOutput;
                        foundFrame?.nextElementSibling.append(labelImage);
                    }
                    index == 0 && updateInfo && foundFrame.click();
                    index++;
                }
                if(event.data.target.closest('input')?.dataset?.htmlOutput) {
                    labelSelected.innerHTML = event.data.target.closest('input').dataset.htmlOutput;
                }                
        }
        _renderRichText(node) {
            if (!node) return '';

            if (node.type === 'root') {
                return node.children.map(child => this._renderRichText(child)).join('');
            }

            if (node.type === 'paragraph') {
                const inner = node.children.map(child => this._renderRichText(child)).join('');
                return `<p>${inner}</p>`;
            }

            if (node.type === 'text') {
                const text = node.value || '';
                if (node.bold) return `<strong>${text}</strong>`;
                return text;
            }

            return '';
        }
    }
    customElements.define('variant-extension', VariantExtension);
}